export const validation = {
  validEmailPhone: "Please enter a valid email or phone number",
  emailPhone: "Please enter a email or phone number",
  country: "Country is required",
  email: "Email is required",
  phoneNumber: "Phone number is required",
  description: "Description must be less then 1000 characters",
};
